<template>
  <!-- viewbox 0 0 18 18,-->
  <path
    d="M4.41602 9.83268L5.06973 11.1401C5.29097 11.5826 5.40159 11.8038 5.54937 11.9956C5.68051 12.1657 5.83302 12.3182 6.00314 12.4493C6.19486 12.5971 6.4161 12.7077 6.85859 12.929L8.16602 13.5827L6.85859 14.2364C6.4161 14.4576 6.19486 14.5683 6.00314 14.716C5.83302 14.8472 5.68051 14.9997 5.54937 15.1698C5.40159 15.3615 5.29097 15.5828 5.06973 16.0253L4.41602 17.3327L3.7623 16.0253C3.54106 15.5828 3.43044 15.3615 3.28266 15.1698C3.15152 14.9997 2.99901 14.8472 2.82889 14.716C2.63717 14.5683 2.41593 14.4576 1.97345 14.2364L0.666016 13.5827L1.97345 12.929C2.41593 12.7077 2.63717 12.5971 2.82889 12.4493C2.99901 12.3182 3.15152 12.1657 3.28266 11.9956C3.43044 11.8038 3.54106 11.5826 3.7623 11.1401L4.41602 9.83268Z"
    fill="url(#paint0_linear_4224_30411)"
  />
  <path
    d="M11.4993 0.666016L12.4815 3.2197C12.7165 3.83072 12.834 4.13624 13.0168 4.39322C13.1787 4.62098 13.3777 4.81997 13.6055 4.98192C13.8625 5.16465 14.168 5.28215 14.779 5.51716L17.3327 6.49935L14.779 7.48153C14.168 7.71654 13.8625 7.83405 13.6055 8.01678C13.3777 8.17873 13.1787 8.37772 13.0168 8.60548C12.8341 8.86246 12.7165 9.16798 12.4815 9.779L11.4994 12.3327L10.5172 9.779C10.2822 9.16798 10.1646 8.86246 9.98192 8.60548C9.81997 8.37772 9.62098 8.17873 9.39322 8.01678C9.13624 7.83405 8.83072 7.71654 8.2197 7.48153L5.66602 6.49935L8.2197 5.51716C8.83072 5.28215 9.13624 5.16465 9.39322 4.98192C9.62098 4.81997 9.81997 4.62098 9.98192 4.39322C10.1646 4.13623 10.2822 3.83072 10.5172 3.2197L11.4993 0.666016Z"
    fill="url(#paint1_linear_4224_30411)"
  />
  <path
    d="M4.41602 9.83268L5.06973 11.1401C5.29097 11.5826 5.40159 11.8038 5.54937 11.9956C5.68051 12.1657 5.83302 12.3182 6.00314 12.4493C6.19486 12.5971 6.4161 12.7077 6.85859 12.929L8.16602 13.5827L6.85859 14.2364C6.4161 14.4576 6.19486 14.5683 6.00314 14.716C5.83302 14.8472 5.68051 14.9997 5.54937 15.1698C5.40159 15.3615 5.29097 15.5828 5.06973 16.0253L4.41602 17.3327L3.7623 16.0253C3.54106 15.5828 3.43044 15.3615 3.28266 15.1698C3.15152 14.9997 2.99901 14.8472 2.82889 14.716C2.63717 14.5683 2.41593 14.4576 1.97345 14.2364L0.666016 13.5827L1.97345 12.929C2.41593 12.7077 2.63717 12.5971 2.82889 12.4493C2.99901 12.3182 3.15152 12.1657 3.28266 11.9956C3.43044 11.8038 3.54106 11.5826 3.7623 11.1401L4.41602 9.83268Z"
    stroke="url(#paint2_linear_4224_30411)"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11.4993 0.666016L12.4815 3.2197C12.7165 3.83072 12.834 4.13624 13.0168 4.39322C13.1787 4.62098 13.3777 4.81997 13.6055 4.98192C13.8625 5.16465 14.168 5.28215 14.779 5.51716L17.3327 6.49935L14.779 7.48153C14.168 7.71654 13.8625 7.83405 13.6055 8.01678C13.3777 8.17873 13.1787 8.37772 13.0168 8.60548C12.8341 8.86246 12.7165 9.16798 12.4815 9.779L11.4994 12.3327L10.5172 9.779C10.2822 9.16798 10.1646 8.86246 9.98192 8.60548C9.81997 8.37772 9.62098 8.17873 9.39322 8.01678C9.13624 7.83405 8.83072 7.71654 8.2197 7.48153L5.66602 6.49935L8.2197 5.51716C8.83072 5.28215 9.13624 5.16465 9.39322 4.98192C9.62098 4.81997 9.81997 4.62098 9.98192 4.39322C10.1646 4.13623 10.2822 3.83072 10.5172 3.2197L11.4993 0.666016Z"
    stroke="url(#paint3_linear_4224_30411)"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <defs>
    <linearGradient
      id="paint0_linear_4224_30411"
      x1="0.998699"
      y1="17"
      x2="2.62422"
      y2="-0.348298"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#00A851" />
      <stop offset="1" stop-color="#00DA6C" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_4224_30411"
      x1="0.998699"
      y1="17"
      x2="2.62422"
      y2="-0.348298"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#00A851" />
      <stop offset="1" stop-color="#00DA6C" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_4224_30411"
      x1="0.998699"
      y1="17"
      x2="2.62422"
      y2="-0.348298"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#00A851" />
      <stop offset="1" stop-color="#00DA6C" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_4224_30411"
      x1="0.998699"
      y1="17"
      x2="2.62422"
      y2="-0.348298"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#00A851" />
      <stop offset="1" stop-color="#00DA6C" />
    </linearGradient>
  </defs>
</template>
